<template>
  <v-container class="container_wrap edit_offer" style="padding-left: 0; padding-right: 10px;">
    <v-row class="text-center title">
      <v-col cols="8">
        <h1>Edit Offer</h1>
      </v-col>
      <v-col cols="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <span
                  v-bind="attrs"
                  v-on="on"
              >
                <label class="editMode" v-show="checkEditMode()">
                    <i class="fas fa-exclamation-triangle" data-fa-transform="shrink-2"></i>
                </label>
              </span>
          </template>
          <span>You have unsaved changes</span>
        </v-tooltip>

      </v-col>
      <v-col cols="3">
        <b-button v-show="checkEditMode()" class="btn-cancel-edit margin-right-10" @click="this.cancelEdit">
          <i class="fas fa-ban" data-fa-transform="shrink-2"></i> Cancel
        </b-button>
        <b-button class="btn-save btn-primary" @click="this.saveOffer">
          <i class="fas fa-save" data-fa-transform="shrink-2"></i> Save
        </b-button>
      </v-col>
    </v-row>

    <div id="edit-offer">
      <v-row class="text-center title">
        <v-col cols="2">
          <div class="condition__controls">
            <label>ID</label>
            <input type="text"
                   class="condition__matches campaign custom-input offer-id"
                   :value="id"
                   disabled
            >
          </div>
        </v-col>
        <v-col cols="2" style="margin-left: -120px">
          <div class="condition__controls">
            <label>ExternalId</label>
            <input type="text"
                   :value="getOffer.externalId"
                   class="condition__matches campaign custom-input offer-external-id"
                   :id="defineId(`externalId`,id)"
                   @change="updValue($event, `externalId`)"
                   maxlength="20"
            >
          </div>
        </v-col>
        <v-col cols="3">
          <div class="condition__controls">
            <label>Name</label>
            <input type="text"
                   placeholder="ex: iPhone 11"
                   :value="getOffer.name"
                   class="condition__matches campaign custom-input offer-name"
                   :id="defineId(`offerName`,id)"
                   @change="updValue($event, `name`)"
                   maxlength="120"
            >
          </div>
        </v-col>
        <v-col cols="4">
          <div class="condition__controls">
            <label>Offer Manager</label>
            <select
                :id="defineId(`advertiserManagerId`,id)"
                class="condition__dimension-name condition__matches custom-select"
                @change="updValue($event, `advertiserManagerId`)"
            >
              <option :value="null"></option>
              <option
                  v-for="{id, firstName, lastName} in getSflAdvertisersManagers"
                  :selected="id === getOffer.advertiserManagerId "
                  :key="id"
                  :id="id"
              >{{firstName}} {{lastName}}
              </option>
            </select>
          </div>
        </v-col>
      </v-row>

      <v-row class="text-center offer-tabs">
        <b-tabs content-class="mt-3">
          <b-tab title="General" active>
            <v-row class="text-center offer-description">
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Description (public)</label>
                  <b-form-textarea
                      id="textarea"
                      placeholder="Description or notes about this offer..."
                      rows="3"
                      max-rows="4"
                      :value="getOffer.descriptions"
                      @change="updValue($event, `descriptions`)"
                  ></b-form-textarea>
                </div>
              </v-col>
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Restrictions (public)</label>
                  <b-form-textarea
                      id="textarea"
                      placeholder="Restrictions or notes about this offer..."
                      rows="3"
                      max-rows="4"
                      :value="getOffer.restrictions"
                      @change="updValue($event, `restrictions`)"
                  ></b-form-textarea>
                </div>
              </v-col>
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Notes (private)</label>
                  <b-form-textarea
                          id="textarea"
                          placeholder="Internal notes about this offer..."
                          rows="3"
                          max-rows="4"
                          :value="getOffer.internalNotes"
                          @change="updValue($event, `internalNotes`)"
                  ></b-form-textarea>
                </div>
              </v-col>
            </v-row>

            <v-row class="text-center general_tab">
              <v-col cols="4">
                <div class="condition__controls">
                  <label>Advertiser</label>

                  <select
                      :id="defineId(`advertiser`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `advertiserId`)"
                  >
                    <option :value="null">-- Select advertiser --</option>
                    <option
                        v-for="{id, name} in getSflAdvertisers"
                        :selected="id === getOffer.advertiserId "
                        :key="id"
                    >{{name}}
                    </option>


                  </select>
                </div>
              </v-col>

              <v-col cols="4">
                <div class="condition__controls">
                  <label>Vertical</label>
                  <select
                      :id="defineId(`verticalId`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `verticalId`)"
                  >
                    <option :value="null">-- Select verticals --</option>
                    <option
                        v-for="{id, name} in getVerticals"
                        :selected="id === getOffer.verticalId"
                        :key="id"
                    >{{name}}
                    </option>
                  </select>
                </div>
              </v-col>

              <v-col cols="4">
                <div class="condition__controls">
                  <label>Status</label>
                  <select
                      :id="defineId(`offerStatus`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `status`)"
                      :disabled="this.isRestricted"
                  >
                    <option
                        id="filterType"
                        v-for="{id, name} in getStatusList()"
                        :selected="formatStr(name) === formatStr(getOffer.status || '')"
                        :key="id"
                    >{{name}}
                    </option>

                  </select>
                </div>
              </v-col>

              <v-col cols="6" style="margin-left: 10px">
                <div class="campaign-block condition__controls">
                  <label for="label-platform" style="float:none">Conversion Flow Type</label>
                  <div class="btn-group btn-group-toggle flex row wrap" data-toggle="buttons">

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              v-on="on"
                              type="radio"
                              :checked="checkConversionType(`cpi`)"
                              name="radio"
                              @change="updValue(`cpi`, `conversionType`)"
                          >
                          CPI <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per install</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              v-on="on"
                              type="radio"
                              :checked="checkConversionType(`cpa`)"
                              @change="updValue(`cpa`, `conversionType`)"
                              name="radio"
                          >
                          CPA <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per action</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              v-on="on"
                              type="radio"
                              :checked="checkConversionType(`cpc`)"
                              @change="updValue(`cpc`, `conversionType`)"
                              name="radio"
                          >
                          CPC <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per click</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                                  v-bind="attrs"
                                  v-on="on"
                                  type="radio"
                                  :checked="checkConversionType(`cps`)"
                                  @change="updValue(`cps`, `conversionType`)"
                                  name="radio"
                          >
                          CPS <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per sale</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                                  v-bind="attrs"
                                  v-on="on"
                                  type="radio"
                                  :checked="checkConversionType(`cpr`)"
                                  @change="updValue(`cpr`, `conversionType`)"
                                  name="radio"
                          >
                          CPR <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per registration</span>
                      </v-tooltip>
                    </label>

                  </div>

                </div>
              </v-col>

              <v-col cols="2" v-show="checkConversionType(`revShare`)">
                <div class="condition__controls percentage">
                  <label>RevShare Payout</label>
                  <input type="number"
                         class="condition__matches campaign custom-input payoutPercent"
                         :value="getOffer.payoutPercent"
                         @change="updValue($event, `payoutPercent`)"
                         v-show="checkConversionType(`revShare`)"
                         step=1
                         min="0"
                         max="999"
                         onkeypress="
                                          return (
                                              event.charCode == 8
                                              || event.charCode == 0
                                              || event.charCode == 13
                                          ) ? null : (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
                         onpaste="return false"
                  >
                </div>
              </v-col>

              <v-col cols="2" v-show="checkConversionType(`hybrid/multistep`)">
                <div class="condition__controls">
                  <label>&nbsp;</label>
                  <b-form-checkbox
                      size="lg"
                      type="checkbox"
                      class="condition__matches campaign"
                      :checked="!!getOfferField(`isCpmOptionEnabled`)"
                      @change="updValue($event, `isCpmOptionEnabled`)"
                      v-show="checkConversionType(`hybrid/multistep`)"
                  >
                    Enable CPM Option
                  </b-form-checkbox>
                </div>
              </v-col>
            </v-row>

            <v-col cols="2">
            </v-col>

            <v-row class="text-center defaultsettings">
              <v-col cols="10">
                <div class="condition__controls">
                  <div class="pull-right"></div>

                  <span class="label">
                      Default LP
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <button
                              v-bind="attrs"
                              v-on="on"
                              class="question"
                          >
                            <i class="fad fa-question-circle"></i>
                          </button>
                        </template>
                        <span>Add a new LP and make sure it's selected</span>
                      </v-tooltip>
                    </span>
                  <span>
                        <b-button variant="light" class="btn-add-line pull-right" v-b-modal.modal-scrollable
                                  @click="showCustomLPModal(id)"
                        >
                            <i class="far fa-cog"></i> Add LP/Customize
                        </b-button>
                        <CustomLP :id="'modal_lp' + id" :ref="'modal_lp' + id"
                                  :customLPId="id"
                                  :defaultLp="getLpDefault"
                                  :customLPRules="getOffer.customLPRules && JSON.parse(getOffer.customLPRules)">
                        </CustomLP>
                    </span>
                  <model-select
                      :options="getLpModify()"
                      :id="defineId(`lpsId`,id)"
                      placeholder="Search landing page..."
                      :value="getLPValue()"
                      @input="updValue($event,`defaultLp`)"
                      class="select"
                  >
                  </model-select>
                </div>
              </v-col>
              <v-col cols="2">
                <div class="condition__controls" style="margin-top: 38px; margin-left: -10px;">
                  <label>&nbsp;</label>
                  <button v-show="this.fastLpAdd" class="btn btn-link pull-left" @click="fastAddLp(id)"
                          v-b-tooltip.hover.bottom="'ADD'">
                    <i class="far fa-plus"></i>
                  </button>

                  <v-tooltip bottom>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <button
                          v-bind="attrs"
                          v-on="on"
                          @click="copyText()"
                          class="btn btn-link pull-left"
                      >
                        <i class="far fa-copy"></i>
                      </button>
                    </template>
                    <span>Copy URL</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <button
                          v-bind="attrs"
                          v-on="on"
                          @click="openURL()"
                          class="btn btn-link pull-left"
                      >
                        <i class="far fa-external-link-alt"></i>
                      </button>
                    </template>
                    <span>Open URL in a new tab</span>
                  </v-tooltip>

                </div>
              </v-col>

              <v-col cols="6">
                <div class="condition__controls">
                  <span style="opacity: 0">&nbsp;.</span>
                  <span class="label">Exit Traffic
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <button
                              v-bind="attrs"
                              v-on="on"
                              class="question"
                          >
                            <i class="fad fa-question-circle"></i>
                          </button>
                        </template>
                        <span>Traffic to send out if there is a redirect</span>
                      </v-tooltip>
                    </span>

                </div>

                <div class="condition__controls" >
                  &#8205;
                  <custom-select
                    :options="getExitTrafficOffers"
                    label="nameId"
                    @search="exitTrafficOffersUpd"
                    :filterable="false"
                    :value="getOffer.offerIdRedirect && getOffer.exitTrafficOfferName ? getOffer.exitTrafficOfferName + ' ' + getOffer.offerIdRedirect : ''"
                    class="custom_select"
                    @input="updValue($event,`offerIdRedirect`)"
                    :clearable="false"
                >
                  </custom-select>
                </div>
              </v-col>
              <v-col cols="6">
              </v-col>

              <v-col cols="6">
                <div class="condition__controls">
                    <span class="label">Postback for the Advertiser
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <button
                              v-bind="attrs"
                              v-on="on"
                              class="question"
                          >
                            <i class="fad fa-question-circle"></i>
                          </button>
                        </template>
                        <span>For each conversion, add the matching LID where indicated at the end and call this URL</span>
                      </v-tooltip>
                    </span>

                  <input type="text"
                         :value="postback"
                         class="condition__matches campaign custom-input disabled"
                         maxlength="25"
                         @click="generatePostback()"
                  >
                </div>
              </v-col>
              <v-col cols="1">
                <div class="condition__controls" style="margin-top: 35px; margin-left: -10px;">
                  <label>&nbsp;</label>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <button
                          v-bind="attrs"
                          v-on="on"
                          class="btn btn-link pull-left"
                          @click="copyPostBack(postback)"
                      >
                        <i class="far fa-copy"></i>
                      </button>
                    </template>
                    <span>Copy URL</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="6" v-if="user[0].can('manage_restricted_offers')">
                <div class="condition__controls">
                  <div class="is_restricted_text">Restricted Offer</div>
                  <v-switch v-model="isRestricted" class="is_restricted_switch"></v-switch>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6">
                <FileManager ref="fileUploader" :offerId="getOffer.id"/>
              </v-col>

            </v-row>
          </b-tab>

          <b-tab title="Program" :disabled="!user[0].can('edit_payin_payout')">
              <v-container fluid>
                <v-row no-gutters>
                  <v-col cols="5">
                    <v-autocomplete
                        hide-details
                        :disabled="!user[0].can('assign_programs')"
                        label="Active Program"
                        v-model="activeProgramId"
                        :items="programsPrepared"
                        placeholder="Start typing to Search"
                    />
                  </v-col>
                  <v-spacer />
                  <v-col cols="5" class="d-flex align-center justify-end text-right">
                    <a v-if="user[0].can('create_programs')"
                       class="new-program"
                       @click="newProgram()"
                    >
                      <b>Need a new program?</b>
                      <v-icon>mdi-open-in-new</v-icon>
                    </a>
                  </v-col>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-center">
                            Code
                          </th>
                          <th class="text-center">
                            Geo
                          </th>
                          <th class="text-center">
                            Payout ( <span v-text="programCurrencyAbbr"></span> )
                          </th>
                          <th v-if="user[0].can('see_profit')" class="text-center">
                            Price ( <span v-text="programCurrencyAbbr"></span> )
                          </th>
                          <th v-if="user[0].can('see_profit')" class="text-center">
                            Margin
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(program, index) in preparedProgramsForTable"
                            :key="index"
                        >
                          <td class="text-center">{{ program.geo }}</td>
                          <td class="text-center">{{ program.countryName }}</td>
                          <td class="text-center">{{ program.payout }}</td>
                          <td v-if="user[0].can('see_profit')" class="text-center">{{ program.price }}</td>
                          <td v-if="user[0].can('see_profit')" class="text-center">{{ program.margin }}</td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
          </b-tab>

          <b-tab title="Restrictions">
            <v-row class="text-center restrictions_tab">
              <v-col cols="11">
                <div class="condition__controls">
                  <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <label class="pull-left">GEO Settings
                      <span class="question"
                            v-b-tooltip.hover.right.html="'Allow or ban certain countries from traffic'">
                        <i class="fad fa-question-circle"></i>
                      </span>
                    </label>

                  </div>

                  <div style="text-align: left; margin-top: 10px;">
                    <span style="color: red; font-weight: bold; display: block;">Banned GEOs:</span>
                    <span style="display: block; white-space: pre-wrap; word-wrap: break-word;">
                    {{ getBannedCountries() }}
                  </span>
                  </div>

                  <div style="text-align: left; margin-top: 10px;">
                    <span style="color: green; font-weight: bold; display: block;">Allowed GEOs:</span>
                    <span style="display: block; white-space: pre-wrap; word-wrap: break-word;">
                    {{ getAllowedCountries() }}
                  </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="1">
                <div class="condition__controls">
                  <label>&nbsp;</label>
                  <b-button variant="light" class="btn-add-line pull-left" v-b-modal.modal
                            @click="showGeoRestrictionsModal(id)"
                  >
                    <i class="far fa-cog"></i> Customize
                  </b-button>

                  <GeoRestrictions :id="'modal_' + id" :ref="'modal_' + id"
                                   :geoId="id"
                                   :geoRules="getOffer.geoRules && getOffer.geoRules"
                                   :offerDefaultLPInfo="getDefaultLPInfo(getOffer.defaultLp)"
                  >
                  </GeoRestrictions>
                </div>
              </v-col>
              <v-col cols="11">
                <div class="condition__controls">
                  <label class="pull-left">Caps</label>
                  <div v-b-tooltip.hover.v-info.bottom.html="getCapsDetails()">
                    <input type="text"
                           class="condition__matches campaign custom-input"
                           :value="getCapsStatus(getOfferCap)"
                           @click="showCapsModal(id)"
                           readonly
                    >
                  </div>
                </div>
              </v-col>
              <v-col cols="1">
                <div class="condition__controls">
                  <label>&nbsp;</label>
                  <b-button variant="light" class="btn-add-line pull-left" v-b-modal.modal-scrollable
                            @click="showCapsModal(id)"
                  >
                    <i class="far fa-cog"></i> Customize
                  </b-button>

                  <Caps :id="'modal_caps' + id" :ref="'modal_caps' + id"
                        :offerId="id"
                        :offerCap="getOfferCap"
                        :offers="getOffersModify()"
                  >
                  </Caps>
                </div>
              </v-col>
              <!--                <v-col cols="5">-->
              <!--                </v-col>-->
              <v-row style="margin-left: 15px">
                <b-row>
                  <b-col cols="3">
                    <div class="condition__controls">
                      <b-form-checkbox
                          size="lg"
                          type="checkbox"
                          class="condition__matches campaign offerCapCheckbox"
                          :checked="!!(getOffer.useStartEndDate === null ? 1 : getOffer.useStartEndDate)"
                          @change="updValue($event,`useStartEndDate`)"
                      >
                        Use date
                      </b-form-checkbox>
                    </div>
                  </b-col>

                  <b-col cols="3">
                    <div class="condition__controls">

                        <v-menu

                            v-model="starDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Start date"
                                readonly
                                :value="getOffer.startDate"
                                :disabled="!!!(getOffer.useStartEndDate === null ? 1 : getOffer.useStartEndDate)"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              locale="en-in"
                              no-title
                              @input="updStartDate"
                          ></v-date-picker>
                        </v-menu>
                    </div>
                  </b-col>
                  <b-col cols="3">
                    <div class="condition__controls">

                        <v-menu

                            v-model="endDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                label="End date"
                                readonly
                                :value="getOffer.endDate"
                                :disabled="!!!(getOffer.useStartEndDate === null ? 1 : getOffer.useStartEndDate)"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              locale="en-in"
                              no-title
                              @input="updEndDate"
                          ></v-date-picker>
                        </v-menu>
                    </div>
                  </b-col>
                </b-row>

              </v-row>
            </v-row>
          </b-tab>

          <b-tab title="History">

            <table class="table table-striped child-row tableFixHead lp-table no-border">
              <thead>
              <tr scope="row">
                <th scope="col">User (E-mail)</th>
                <th scope="col">Date/Time</th>
                <th scope="col">Action</th>
                <th scope="col">Changes</th>
              </tr>
              </thead>
              <tr scope="row" v-for="(history, index) in getOfferHistoryModify() " :key="index">
                <td class="text-center" >
                  <span>{{history.user}}</span>
                </td>
                <td class="text-center" >
                  <span>{{ formatDate_(new Date(history.dateAdded * 1000)) }}</span>
                </td>
                <td class="text-center" >
                  <span>{{ history.action }}</span>
                </td>
                <td class="text-left" style="padding-left: 15% !important;">
                  <HistoryLog :logsString='history.logs' ></HistoryLog>
                </td>
              </tr>
            </table>
          </b-tab>
        </b-tabs>
      </v-row>
    </div>
    <Confirm ref="confirm"></Confirm>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
  import {mapGetters, mapMutations, mapState} from 'vuex'
  import {formatData, cloneObjectArray, isValidUrl} from '../../../../helpers'
  import GeoRestrictions from './GeoRestrictions'
  import Caps from './Caps'
  import CustomLP from './CustomLP'
  // import OfferLP from './offerLP'
  import {ModelSelect} from 'vue-search-select'
  import 'bootstrap/dist/css/bootstrap.css';
  import MainLayout from "../../../layouts/MainLayout"
  import Confirm  from "../../../common/Confirm";
  import offerApi from '../../../../api/offer';
  import 'vue-select/dist/vue-select.css'
  import {debounce} from "debounce";
  import store from '../../../../store'
  import programs from "@/api/programs";
  import HistoryLog from "@/components/common/HistoryLog";
  import FileManager  from "@/components/common/FileManager";
  import affiliates from "@/api/affiliates";

  export default {
    name: 'editOffer',
    components: {
      GeoRestrictions,
      Caps,
      CustomLP,
      // OfferLP,
      ModelSelect,
      MainLayout,
      Confirm,
      HistoryLog,
      FileManager
    },
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters('offer', [
        'getOffer',
        'getOfferOrigin',
        'getOfferCap',
        'getOfferCapOrigin',
        'getOfferGeo',
        'getOfferGeoOrigin',
        'getCustomLPRules',
        'getCustomLPRulesOrigin',
        'getExitTrafficOffers'
      ]),
      ...mapGetters('offers', ['getOffers']),
      ...mapGetters('offerHistory', ['getOfferHistory']),
      ...mapGetters('lpOffers', ['getLpOffers', 'getLpOffersOrigin']),
      ...mapGetters('countries', ['getCountries']),
      ...mapGetters('advertisers', ['getSflAdvertisers', 'getSflAdvertisersManagers']),
      ...mapGetters('verticals', ['getVerticals']),
      programsPrepared() {
        const tempProgramList = JSON.parse(JSON.stringify(this.programList));
        tempProgramList.map(program => {
          program['text'] =  `${program.name} (${program.id})`;
          program['value'] = program.id;
        });
        return tempProgramList;
      },
      preparedProgramsForTable() {
        const preparedProgramsForTable = [...this.programDetails];

        const activeProgramData = this.programList.find(value => value.id === this.activeProgramId) || {};

        const marginPercent = activeProgramData && activeProgramData.marginType === 'fixed' ?
                Math.round((1 - (activeProgramData.payout / activeProgramData.price)) * 100)
                : activeProgramData.marginPercent;

        const defaultData = {
          countryName: 'Worldwide (Default)',
          geo: 'WW',
          price: activeProgramData.price || 0,
          payout: activeProgramData.payout || 0,
          margin: `${Math.round((activeProgramData.price - activeProgramData.payout) * 100) / 100} (${marginPercent || '0'}%)`,
          nextGeo: '',
          nextCode: '',
          nextPrice: '',
          nextPayout: '',
          nextMargin: ''
        };

        if (activeProgramData.payout > 0){
          preparedProgramsForTable.unshift(defaultData);
        }

        return preparedProgramsForTable;
      },
      calculatedPayout(){
        return Number(this.marginType) === 1
                ? this.getOffer.payOut
                :  (Number(this.getOffer.payIn)*100/(100 + Number(this.getOffer.payoutPercent))).toFixed(2);
      },
      advertiserMargin(){
        const advMargin = this.getSflAdvertisers.find(adv => adv.id === this.getOffer.advertiserId)
                ? (this.getSflAdvertisers.find(adv => adv.id === this.getOffer.advertiserId)).margin
                : 0;

        if (this.getOffer.payoutPercent === null && this.getOffer.advertiserId !== null) {
          this.updOffer({fieldName: 'payoutPercent', value: advMargin})
        }
        return advMargin;
      },
      programCurrencyAbbr() {
        return this.activeProgram ? this.activeProgram.currencyAbbr : 'USD';
      }
    },
    async created() {
      if (!this.user[0].can('manage_offers')){
        await this.$router.push('/403');
      }
    },
    async mounted() {
      this.loading = true;
      document.title = `Offer-${this.$route.params.id}`;
      this.platform = await affiliates.getPlatform()
      // console.log('this.platform:', this.platform)
      await this.$store.dispatch('offer/saveExitTrafficOffersStore')
      await this.$store.dispatch('offer/saveOfferStore', this.id)


      const allowedCountries = await programs.getAllowedCountriesByOfferId(this.id);
      this.allowedCountries = allowedCountries.countries || [];
      this.isAllCountriesAllowed = allowedCountries.isAllCountriesAllowed;
      await this.$store.dispatch('offer/saveOfferCapStore', this.id)
      await this.$store.dispatch('lpOffers/saveLpOffersStore', this.id)
      await this.$store.dispatch('advertisers/saveSflAdvertisersStore',
          {
            limit: 1500,
            page: 1,
            orderBy: 'name',
            orderDirectionAsc: true,
            filters: {status: '\'active\''}
          })
      // TODO temporary fix limit to 1500, to make gotzha offers works PH-555
      await this.$store.dispatch('advertisers/saveSflAdvertisersManagersStore')
      await this.$store.dispatch('verticals/saveVerticalsStore')

      await this.$store.dispatch('countries/saveCountriesStore')
      await this.$store.dispatch('offerHistory/saveOfferHistoryStore', this.id)

      let lp = cloneObjectArray(this.getLpOffers)
      this.lp = lp
      let self = this
      document.querySelector(`#lpsId-${self.id}`).addEventListener('keyup', (e) => {
        let defaultLpNew = document.querySelector(`#lpsId-${self.id}`).value
        let checkLp = self.lp.filter(item => (item.name.includes(defaultLpNew)))
        if (checkLp.length === 0) {
          self.fastLpAdd = true
          self.fastLpValue = defaultLpNew
        } else {
          self.fastLpAdd = false
        }
        if (e.key === 'Enter') {

        }
      })
      this.isRestricted = this.getOffer.isRestricted
      this.marginType = this.getOffer.marginType === 'fixed' ? '1' : '2'
      this.programList = await programs.getProgramsList();
      await this.fetchProgramData();
      this.originProgramId = this.getOffer.programId;

      if (!this.getOffer.id){
        await this.$router.push('/403');
      }

      this.loading = false;

    },
    watch: {
      async activeProgramId() {
        if (!this.activeProgramId || isNaN(this.activeProgramId)) return;
        const allowCountries = this.allowedCountries
        const programDetails = await programs.getProgramDetails(this.activeProgramId);
        if (allowCountries.length !== 0 && !this.isAllCountriesAllowed) {
          this.programDetails = programDetails.filter(detail => allowCountries.includes(detail.geo));
        } else {
          this.programDetails = programDetails;
        }

        this.activeProgram = this.programList.find(program => program.id === this.activeProgramId);
        this.tempIndex = 0;
        this.$forceUpdate();
      },
      isRestricted: async function () {
        await this.updOffer({fieldName: 'isRestricted', value: this.isRestricted})
        let status = this.isRestricted ? 'private' : 'public'
        await this.updOffer({fieldName: 'status', value: status})
      },
    },
    methods: {
      ...mapMutations('offer', ['updOffer','delOOfferCustomPayoutPerGeo']),
      ...mapMutations('lpOffers', ['fastAddLpOffers']),
      ...mapMutations('countries', ['filterCountry']),
      newProgram() {
        window.open(`/advertisers/programs/create`, '_blank');
      },
      prepareProgramData(index, program = {}) {
        if (index === 0) {
          this.tempIndex = 0;

          let activeProgramData = {};
          this.programList.forEach(value => {
            if (value.id === this.activeProgramId) {
              activeProgramData = value;
            }
          });

          if (activeProgramData.payout > 0) {
            let marginPercent = activeProgramData.marginType === 'fixed'
                ? Math.round((activeProgramData.price / activeProgramData.payout - 1) * 100)
                : activeProgramData.marginPercent;

            const defaultData = {
              code: 'WW',
              geo: 'Worldwide (Default)',
              price: activeProgramData.price,
              payout: activeProgramData.payout,
              margin: `${Math.round((activeProgramData.price - activeProgramData.payout) * 100) / 100} (${marginPercent}%)`,
              nextGeo: this.programDetails[this.tempIndex].countryName,
              nextCode: this.programDetails[this.tempIndex].geo,
              nextPrice: this.programDetails[this.tempIndex].price,
              nextPayout: this.programDetails[this.tempIndex].payout,
              nextMargin: this.programDetails[this.tempIndex].margin,
            };

            this.tempIndex++;
            return defaultData;
          }
        }

        const data = {};

        if (this.tempIndex < this.programDetails.length) {
          data['geo'] = this.programDetails[this.tempIndex].countryName;
          data['code'] = this.programDetails[this.tempIndex].geo;
          data['price'] = this.programDetails[this.tempIndex].price;
          data['payout'] = this.programDetails[this.tempIndex].payout;
          data['margin'] = this.programDetails[this.tempIndex].margin;
          this.tempIndex++;
        }

        if (this.tempIndex < this.programDetails.length) {
          data['nextGeo'] = this.programDetails[this.tempIndex].countryName;
          data['nextCode'] = this.programDetails[this.tempIndex].geo;
          data['nextPrice'] = this.programDetails[this.tempIndex].price;
          data['nextPayout'] = this.programDetails[this.tempIndex].payout;
          data['nextMargin'] = this.programDetails[this.tempIndex].margin;
          this.tempIndex++;
        }

        return data;
      },
      updStartDate(date) {
        this.updValue(date, 'startDate')
        this.starDateMenu = false
      },
      updEndDate(date) {
        this.updValue(date, 'endDate')
        this.endDateMenu = false
      },
      getCountriesModify() {
        return this.getCountries.map(item => {
          item.value = item.code
          item.text = item.name + ' (' + item.code + ') '
          return item
        })
      },
      checkEditMode() {
        if (JSON.stringify(this.getOfferOrigin) !== JSON.stringify(this.getOffer)
          || JSON.stringify(this.getOfferCapOrigin) !== JSON.stringify(this.getOfferCap)
          || JSON.stringify(this.getLpOffersOrigin) !== JSON.stringify(this.getLpOffers)
          || JSON.stringify(this.getOfferGeoOrigin) !== JSON.stringify(this.getOfferGeo)
          || JSON.stringify(this.getCustomLPRulesOrigin) !== JSON.stringify(this.getCustomLPRules)
          || this.activeProgramId !== this.originProgramId
        ) {
          return true
        }
      },
      getOfferHistoryModify() {
        return this.getOfferHistory.length !== 0 && this.getOfferHistory
      },
      getBannedCountries() {
        if (this.getOffer.geoRules) {

          let geoR = JSON.parse(this.getOffer.geoRules)
          let geoCountry = geoR.geo.map(item => item.country)
          return geoCountry.join(', ')
        }
      },
      getAllowedCountries() {
        if (this.getOffer.geoRules) {
          let geoR = JSON.parse(this.getOffer.geoRules);
          let bannedCountries = geoR.geo.map(item => item.country);

          const allCountries = this.getCountries.map(item => item.code);
          const allowedCountries = allCountries.filter(country => !bannedCountries.includes(country));

          return allowedCountries.join(', ');
        }
        return '';
      },
      getBannedCountriesStatus() {
        if (!this.getOffer.geoRules) return
        let geoR = JSON.parse(this.getOffer.geoRules)
        let geoCountry = geoR.geo.map(item => item.country)
        if (geoCountry.length !== 0) {
          return `Banned Countries (hover for list)`
        } else {
          return `All Countries Allowed`
        }
      },
      getCapsStatus(caps) {
        return caps.enabled === 0 && `Caps disabled` || `Caps enabled`
      },
      getCapsDetails() {
        const {clickDay, clickWeek, clickMonth, salesDay, salesWeek, salesMonth} = this.getOfferCap
        return `-Clicks-\n
                Day: ${clickDay} Week: ${clickWeek} Month: ${clickMonth}\n
                -Conversions-\n
                Day: ${salesDay} Week: ${salesWeek} Month: ${salesMonth}`
      },
      fastAddLp(id) {
        let newLp = this.fastLpValue.replace(/\s/g, '')
        if (!isValidUrl(newLp)) {
          this.$dialog.error({
            text: `<p style="color:#262a2d; font-style: normal; font-size: 17px;"> You have entered an invalid site name { ${this.fastLpValue} }.  <p>Please enter the correct site name.</p>`,
            title: `Validation error`
          })
          return
        }
        let prefix = 'http'
        if (newLp.substr(0, prefix.length) !== prefix) {
          newLp = prefix + '://' + newLp
        }

        let obj = {}
        obj.url = newLp
        obj.offerId = id
        this.fastAddLpOffers(obj)

        const getLastId = (sf) => {
          let loadMin = null
          for (const item of sf) {
            if (!loadMin || item.id > loadMin.id) {
              loadMin = item
            }
          }
          return loadMin.id
        }

        let lastId = getLastId(this.getLpOffers) || 0
        let obj2 = {}
        obj2.fieldName = 'defaultLp'
        obj2.value = lastId
        this.updOffer(obj2)

        const res = this.$dialog.info({
          text: `Site ${newLp} added`,
          title: 'Info'
        })
        this.fastLpAdd = false

      },
      async copyText() {
        try {
          let obj = this.getLpOffers.filter(item => (item.id === this.getOffer.defaultLp))
          await navigator.clipboard.writeText(obj[0].url);
          this.$swal.fire({
            type: 'success',
            position: 'top-end',
            title: `Copied URL to clipboard`,
            text: `${obj[0].url}`,
            showConfirmButton: false,
            timer: 2000
          })
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
      },

      async copyPostBack(postback) {
        try {
          await navigator.clipboard.writeText(postback);
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
      },

      openURL() {
        let obj = this.getLpOffers.filter(item => (item.id === this.getOffer.defaultLp))
        let url = obj[0].url

        let prefix = 'http'

        if (url.substr(0, prefix.length) !== prefix) {
          url = prefix + '://' + url
        }

        window.open(url, '_blank');
      },
      getLpURL() {
        if (this.getOffer.length !== 0) {

          let obj = this.getLpOffers.filter(item => (item.id === this.getOffer.defaultLp))
          return obj.length !== 0 && 'Name: ' + obj[0].name + '<br>URL: ' + obj[0].url + '<br>(ID: ' + obj[0].id + ')'
        }
      },
      getLPValue() {
        if (this.getOffer.length !== 0) {
          return this.getOffer.defaultLp
        }
      },
      getLpDefault() {
        if (this.getOffer.length !== 0) {
          return this.getOffer.defaultLp
        }
      },
      getLpModify() {
        let lpModify = cloneObjectArray(this.getLpOffers)
        return lpModify.map(item => {
          item.value = item.id
          item.text = `${item.url}`
          return item
        })
      },
      getDefaultLPInfo(defaultLp) {
        if (!defaultLp) return
        return this.getLpOffers.filter(item => {
          return item.id === defaultLp
        })
      },
      getOffersModify() {
        return this.getExitTrafficOffers
      },
      getOfferField(name) {
        if (this.getOffer.length !== 0) {
          return this.getOffer[name]
        }
      },
      async exitTrafficOffersUpd(event) {
        this.debounceUpdateExitOffers(event)
      },
      debounceUpdateExitOffers: debounce(async (search) => {
        await store.dispatch('offer/saveExitTrafficOffersStore', {search})
      }, 700),
      updValue(event, name) {
        try {
          let obj = {}
          if(name === 'marginType') {
            if(Number(this.marginType) === 1) {
              return this.updOffer({fieldName: name, value: 'fixed'});
            } else {
              return this.updOffer({fieldName: name, value: 'percent'});
            }
          }
          if(name === 'payoutPercent') {
            return this.updOffer({fieldName: 'payoutPercent', value: Number(event.target.value)});
          }
          if (
              name === 'conversionType'
              || name === 'defaultLp'
              || name === 'descriptions'
              || name === 'restrictions'
              || name === 'internalNotes'
              || name === 'startDate'
              || name === 'endDate'
              || name === 'offerIdRedirect'
          ) {
            obj.fieldName = name
            obj.value = event.id ? event.id : event
          } else if (name === 'status') {

            obj.fieldName = name
            if (event.target.value.toLowerCase() === 'apply to run') {
              obj.value = `apply_to_run`
            } else {
              obj.value = event.target.value.toLowerCase()
            }

          } else {
            obj.fieldName = name
            if (name === 'isCpmOptionEnabled') {
              obj.value = Number(!this.getOfferField(`isCpmOptionEnabled`))
            } else if (name === 'useStartEndDate'){
              obj.value = Number(event)
            } else if (name === 'payOut' || name === 'payIn'){
              obj.value = Number(event.target.value);
              if(Number(this.marginType) === 1) {
                this.updOffer({fieldName: 'marginType', value: 'fixed'});
              } else {
                this.updOffer({fieldName: 'marginType', value: 'percent'});
              }
            } else {
              obj.value = event.target.value
            }
          }
          if (name === 'advertiserId') {
            let objAdv = {}
            objAdv.fieldName = `advertiserName`
            objAdv.value = event.target.value
            this.updOffer(objAdv)
            let advId = this.getSflAdvertisers.filter(i => i.name.trim() === event.target.value.trim());
            obj.value = advId[0].id

            this.generatePostback();
          }

          if (name === 'verticalId') {
            let objAdv = {}
            objAdv.fieldName = `verticalName`
            objAdv.value = event.target.value
            this.updOffer(objAdv)
            let advId = this.getVerticals.filter(i => (i.name === event.target.value))

            obj.value = advId[0].id
          }


          if (name === 'advertiserManagerId') {
            obj.value = event.target[event.target.selectedIndex].id;
            console.log('adv man id: ', obj.value);
          }

          if (name === 'currencyId') {
            let currency = event.target.value
            let currencyId = this.getCurrencyList().filter(i => (i.name === currency))
            obj.value = currencyId[0].id
          }

          this.fastLpAdd = false
          this.updOffer(obj)
          if (name === 'offerIdRedirect'){
            obj.fieldName = 'exitTrafficOfferName'
            obj.value = event.name
            this.updOffer(obj)
          }
        } catch (e) {
          this.$dialog.error({
            text: `Error: ${e}`,
            title: 'Validation Error'
          })
        }

      },
      disableAutocomplete(id) {
        let addAtr = document.getElementById(id);
        if(addAtr) {
          addAtr.setAttribute('autocomplete', 'disable');
        }
      },
      async cancelEdit() {
        let confirmCancelEdit = await this.$dialog.warning({
          text: `Are you sure?`,
          title: 'Your changes will be discarded.'
        })
        if (confirmCancelEdit){
          this.$router.push("/advertisers/offers")
        }
      },
      delOOfferCustomPayoutPerGeo_(id){
        this.delOOfferCustomPayoutPerGeo(id)
      },
      async saveOffer() {
        this.$refs.fileUploader.send();
        this.updValue(null, 'marginType');
        let offerData = this.getOffer
        let emptyKeyCustomPayout = []

        // if (emptyKeyCustomPayout.length !== 0) {
        //   this.$dialog.error({
        //     text: `customPayOut fields is empty${JSON.stringify(emptyKeyCustomPayout)}`,
        //     title: 'Validation Error'
        //   })
        //   return
        // }

        // if (parseFloat(offerData.payIn) < parseFloat(offerData.payOut)) {
        //   const isConfirmed = await this.$refs.confirm.open('', 'PayOut is more than PayIn. Is it correct?', {color: 'red'});
        //   if (!isConfirmed) {
        //     return
        //   }
        // }

        let emptyKey = []
        let keys = Object.keys(offerData)
        keys.forEach(key => {
          if (
            key === 'geoRules' ||
            key === 'previewLink' ||
            key === 'customLPRules' ||
            key === 'customPayOut' ||
            key === 'payoutPercent' ||
            (key === 'payOut' && (offerData['marginType'] === 'percent')) ||
            key === 'descriptions' ||
            key === 'restrictions' ||
            key === 'caps' ||
            key === 'isCpmOptionEnabled' ||
            key === 'useStartEndDate' ||
            key === 'startDate' ||
            key === 'endDate' ||
            key === 'programId' ||
            key === 'offerIdRedirect' ||
            key === 'isRestricted' ||
            key === 'exitTrafficOfferName' ||
            key === 'externalId' ||
            key === 'internalNotes' ||
            (key === 'payOut' && offerData[key] === 0)||
            (key === 'payIn' && offerData[key] === 0)
          ) {
            return
          }
          if (Number(offerData[key]) === 0) {
            emptyKey.push(key)
          }
        })
        if (!this.activeProgramId){
          emptyKey.push('programId')
        }
        let offerId
        if (offerData.length !== 0) {
          offerId = offerData.id
        }
        let el = document.querySelector(`#lpsId-${offerId}`)
        if (el.nextElementSibling.textContent.indexOf('Search landing page') === 0) {
          emptyKey.push('DefaultLandingPage')
        }
        let mess = ''
        for (let key of emptyKey){
          if (key === 'advertiserId' || key ==='defaultLp') continue
          if (key === 'advertiserName'){
            key = 'advertiser'
          }
          if (key === 'DefaultLandingPage'){
            key = 'Default LP'
          }
          mess += `<p><span style="color:#2d7093">${key}</span></p>`
        }
        if (emptyKey.length !== 0) {
          await this.$dialog.error({
            text: `<p style="color:#262a2d; font-style: normal; font-size: 17px;"> There are some errors, please add those empty fields </p>${mess}`,
            title: 'Validation Error'
          })
          return
        }

        let defaultSiteName = el.nextElementSibling.textContent
        if (defaultSiteName) {
          defaultSiteName = defaultSiteName.replace(/\s/g, '')
        }
        const toSaveObj = {
          defaultSiteName,
          programId: this.activeProgramId,
        }
        const {id} = await this.$store.dispatch('offer/saveOfferDb', toSaveObj)
        if (id) {
          await this.$store.dispatch('lpOffers/saveCurrentLpState')
          const res = await this.$dialog.info({
            text: 'Offer updated',
            title: 'Info'
          })
          // this.$swal.fire({
          //   type: 'success',
          //   position: 'top-end',
          //   title: `Offer updated`,
          //   showConfirmButton: false,
          //   timer: 1000
          // })
          // location.reload()
        } else {
          this.$dialog.error({
            text: `Offer failed to save`,
            title: 'Please check backend errors'
          })
        }


      },
      showGeoRestrictionsModal(id) {
        let modal_id = 'modal_' + id

        this.$refs[modal_id].show(id)
        console.log('this.$refs[modal_id]-', this.$refs[modal_id])
      },
      showCapsModal(id) {
        let modal_id = 'modal_caps' + id

        this.$refs[modal_id].show(id)
        console.log('this.$refs[modal_id]-', this.$refs[modal_id])
      },
      showCustomLPModal(id) {
        let modal_id = 'modal_lp' + id

        this.$refs[modal_id].show(id)
        console.log('this.$refs[modal_id]-', this.$refs[modal_id])
      },
      showOfferAddLpModal(id) {
        let modal_id = 'modal_add_lp' + id

        this.$refs[modal_id].show(id)
        console.log('this.$refs[modal_id]-', this.$refs[modal_id])
      },
      addClassActive(value) {
        return value && 'active' || ''
      },
      checkConversionType(str) {
        let offer = this.getOffer
        // debugger
        if (offer.length !== 0 && offer.conversionType === str) {
          return `checked`
        }

      },
      formatDate_(date) {
        return formatData(date)
      },
      formatStr(str) {
        return str && str.toLowerCase().replace(/_/g, '').replace(/\s/g, '')
      },
      defineId(name, id) {
        this.disableAutocomplete(`${name}-${id}`)
        return `${name}-${id}`
      },
      getCurrencyList() {
        return [
          {id: 1, name: 'USD'},
          {id: 2, name: 'EUR'},
          {id: 3, name: 'BRL'},
          {id: 4, name: 'GBP'},
        ]
      },
      getStatusList() {
        return [
          {id: 0, name: 'Public'},
          {id: 1, name: 'Private'},
          {id: 2, name: 'Apply to Run'},
          {id: 3, name: 'Inactive'},
          {id: 4, name: 'Draft'},
        ]
      },
      changePayoutType() {
        //this.payoutType
        // this.payoutType = !this.payoutType;
      },
      changePayoutTypeGEO() {
        this.payoutTypeGEO
      },

      async generatePostback() {

        const offer = this.getOffer;

        if (!offer.advertiserId) {
          this.postback = 'Please, choose advertiser';
          return;
        }

        this.postback = 'Loading....';
        const res = await offerApi.getPostback(offer.advertiserId);

        console.log('postback22',  this.getOfferField(`advertiserId`))
        this.postback = res.value;
      },
      async fetchProgramData() {
        const activeProgramId = this.getOffer.programId;
        const result = this.programList.find(value => value.id === activeProgramId);
        this.activeProgramId = result ? result.id : null;
        this.activeProgram = result;
      },
    },
    data() {
      return {
        tab: null,
        items: [
          'General', 'Payin/Payout', 'Restrictions', 'History',
        ],
        programList: [],
        allowedCountries: [],
        isAllCountriesAllowed: null,
        programDetails: [],
        activeProgram: null,
        activeProgramId: null,
        originProgramId: null,
        tempIndex: 0,
        loading: false,
        platform: null,
        fastLpAdd: false,
        fastLpValue: '',
        id: Number(this.$route.params.id),
        selected: true,
        marginType: '1',
        payoutTypeGEO: '1',
        startDate: null,
        endDate: null,
        starDateMenu: false,
        endDateMenu: false,
        postback: 'click to generate postback',
        options: {
          // https://momentjs.com/docs/#/displaying/
          format: 'MM/DD/YYYY h:mm:ss',
          useCurrent: true,
          showClear: true,
          showClose: false,
          sideBySide: true,
          icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'fas fa-chevron-up',
            down: 'fas fa-chevron-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-calendar-check',
            clear: 'far fa-ban',
            close: 'far fa-times-circle'
          },
        },
        checkedStartDate: false,
        checkedEndDate: false,
        isRestricted: false,
      };
    }
  };

</script>

<style lang="sass">
  #edit-offer
    label.custom-control-label
      margin-top: 15px

    .conversionType
      display: table-cell
      position: relative
      padding-left: 35px
      margin-bottom: 10px
      cursor: pointer
      font-size: 16px
      border: 2px solid #E3EEF4
      -webkit-user-select: none
      -moz-user-select: none
      -ms-user-select: none
      user-select: none

    .conversionType input
      position: absolute
      opacity: 0
      cursor: pointer

    .conversionTypeCheckMark
      position: absolute
      top: 15px
      left: 15px
      height: 10px
      width: 10px
      background-color: #E3EEF4
      border-radius: 50%

    .conversionType:hover input ~ .conversionTypeCheckMark
      background-color: #ccc

    .conversionType input:checked ~ .conversionTypeCheckMark
      background-color: #36B8E1 !important

    .conversionTypeCheckMark:after
      content: ""
      position: absolute
      display: none

    .conversionType input:checked ~ .conversionTypeCheckMark:after
      display: block

    .conversionType .conversionTypeCheckMark:after
      top: 6px
      left: 6px
      width: 8px
      height: 8px
      border-radius: 50%
      background: transparent

    .conversionType:active
      color: #36B8E1
      border-color: #36B8E1
      z-index: 2

    .conversionType.btn.btn-secondary-:focus-within
      color: #36B8E1
      border-color: #36B8E1
      z-index: 2

    .row.text-center.title
      // position: fixed
      // top: 27px
      z-index: 4
      width: 100%
      // margin-left: 20px

    button.btn.btn-cancel-edit, button.btn.btn-save
      position: initial
      float: left
      width: auto
      padding: 0px 20px
      margin-right: 10px

    .title
      .condition__controls label
        font-size: 14px
        display: inline-block
        text-align: left
        color: #7F98A5
        font-weight: 500
        letter-spacing: 0.3px
        margin-top: 5px
        border-radius: 7px
        float: left

    span.label
      font-size: 14px
      display: inline-block
      text-align: left
      color: #7F98A5
      font-weight: 500
      letter-spacing: 0.3px
      margin-top: 5px
      margin-bottom: 5px
      border-radius: 7px

    .row.text-center.title .col-2
      -ms-flex: 0 0 18%
      flex: 0 0 18%
      max-width: 18%

    .row.text-center.title .col-3
      -ms-flex: 0 0 22%
      flex: 0 0 22%
      max-width: 22%

    .row.text-center.title .custom-input
      position: initial
      width: auto
      color: #7F98A5
      font-size: 16px
      font-weight: 600
      border-radius: 7px
      padding: 10px 15px
      height: 40px
      text-align: left
      border: 2px solid #e3eef4
      margin-left: 10px
      float: left

      &.offer-id
        width: 100px

      &.offer-name
        width: 240px
        text-overflow: ellipsis

      &.offer-external-id
        width: 100px
        text-overflow: ellipsis

    .row.text-center.title .custom-select
      text-align: left
      position: relative
      min-width: 140px
      width: auto
      height: 40px
      border-radius: 7px
      color: #7F98A5
      font-size: 16px
      font-weight: 600
      border: 2px solid #e3eef4
      margin-left: 10px
      float: left
      text-overflow: ellipsis

    .row.text-center.title .condition__controls
      border: 0
      margin-top: -1rem
      margin-bottom: 0rem
      padding-bottom: 0rem

    .row.text-center.title .condition__matches
      margin-right: 0px

    .offer-tabs
      margin-top: 20px

    .basil
      background-color: transparent !important

    .basil--text
      color: #3A3852 !important

    .tabs
      width: 100%
      .tab-content
        max-width: 95vw

      .mt-3, .my-3
        margin-top: 0rem !important
        background: #fff
        padding: 20px
        border-left: 2px solid #E3EEF4
        border-right: 2px solid #E3EEF4
        border-bottom: 2px solid #E3EEF4
        border-radius: 0px 0px 4px 4px

      .nav-tabs .nav-link.active,
      .nav-tabs .nav-item.show .nav-link
        color: #36B8E1
        font-size: 16px
        font-weight: 700
        background-color: #fff
      // border: 2px solid #E3EEF4

      .nav-tabs
          border-bottom: 2px solid #E3EEF4

      .nav-link
        color: #7F98A5
        font-size: 16px
        font-weight: 500
        margin-left: 0px
        margin-bottom: -2px
        padding: 10px 5rem

      .percentage::before
        content: '\F541'
        font-family: "Font Awesome 5 Free"
        font-weight: 900
        font-size: 18px
        color: #ACC3CF
        opacity: 0.7
        float: right
        position: relative
        top: 42px
        right: 15px
        z-index: 1
      .bottom.percentage::before
        top: 37px

      .dollar::before
        content: '\f155'
        font-family: "Font Awesome 5 Free"
        font-weight: 900
        font-size: 18px
        color: #ACC3CF
        opacity: 0.7
        float: left
        position: relative
        top: 43px
        left: 15px
        z-index: 1
      .bottom.dollar::before
        top: 37px
      .euro::before
        content: '\f153'
        font-family: "Font Awesome 5 Free"
        font-weight: 900
        font-size: 18px
        color: #ACC3CF
        opacity: 0.7
        float: left
        position: relative
        top: 43px
        left: 15px
        z-index: 1
      .bottom.euro::before
        top: 37px
      .brl::before
        content: 'R\f155'
        font-family: "Font Awesome 5 Free"
        font-weight: 900
        font-size: 18px
        color: #ACC3CF
        opacity: 0.7
        float: left
        position: relative
        top: 43px
        left: 15px
        z-index: 1
      .bottom.brl::before
        top: 37px
      .gbr::before
        content: '\f154'
        font-family: "Font Awesome 5 Free"
        font-weight: 900
        font-size: 18px
        color: #ACC3CF
        opacity: 0.7
        float: left
        position: relative
        top: 43px
        left: 15px
        z-index: 1
      .bottom.gbr::before
        top: 37px


      input.condition__matches.payIn, input.condition__matches.payOut
        padding-left: 40px

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0

      input[type=number]
        -moz-appearance: textfield

      input.form-control.custom-input.date-picker
        font-size: 16px
        border: 2px solid #E3EEF4
        border-radius: 4px
        padding: 5px 10px 5px 40px
        margin-top: 0px

      span.oldValue
        color: #ACC3CF
        font-weight: 400
        text-decoration: line-through
        margin-right: 5px

      span.newValue
        color: #7F98A5
        font-weight: 600
        margin-left: 5px

.ui.dropdown>.dropdown.icon:before
  content: '\f11c' !important
  font-family: "Font Awesome 5 Free"
  font-weight: 300
  font-size: 16px
  color: #ACC3CF

.ui.default.dropdown:not(.button)>.text, .ui.dropdown:not(.button)>.default.text
  color: #ACC3CF !important
.custom-input-payout
  background-color: #D3D3D3 !important
.default-margin
  font-weight: bold

</style>
